
$('.in-index .products').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
        { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ]
});







$('.customGallery .wrapper .plus-gallery-wrap').slick({
    slidesToShow: 4,
    slidesToScroll: 3,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 5, slidesToScroll: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false } },
        { breakpoint: 479, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ]
});









if ($('.slick-slider').length) {
    $('.slick-slider').each(function () {

        var $wrapper = $('<div class="arrowWrapper"></div>');
        ($(this)).find('.slick-dots').after($wrapper);

        var $arrows = $(this).find('.slick-arrow');


        if ($arrows.length) {
            $arrows.each(function () {
                var $arrow = $(this);

                $arrow.appendTo($wrapper);
            });
        }
    });
}



